//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

// The header elements a tour points at, named here so the header and the
// tour cannot drift apart silently.
export const HEADER_TOUR_ANCHORS = {
  datasetSelector: 'dataset-selector',
  demoDataMenu: 'demo-data-menu'
} as const;
